// extracted by css-extract-rspack-plugin
export default {"root":"mdsFA2SOG70uQNjW","link":"IfdacWTGpeU_WgbL","tile":"PKxuMZGs2oY9z4Op","title":"kDL7sSswsfkL1Pee"};